import type { Customer, Organization } from '@leid/api-customers'

import { signOutCustomer } from 'app/serverActions/authentication'
import apiClient from 'helpers/clients/apiClient'
import { STORAGE_KEYS } from 'utils/constants'
import { removeFromStorage } from 'utils/storage'

export type CustomerInfo = {
  customer: Customer | null
  organization: Organization | null
}

export const clientSignOut = async (): Promise<boolean> => {
  // Remove organization cookie if any
  await apiClient.selectOrganizationOrPersonalAccount(undefined)
  // Remove coordinates cookes is any
  await apiClient.setCustomerCoordinates(undefined)

  const result = await signOutCustomer()
  if (!result) {
    return false
  }

  // Remove from local store
  removeFromStorage(STORAGE_KEYS.orderId)
  removeFromStorage(STORAGE_KEYS.orderToken)
  removeFromStorage(STORAGE_KEYS.userToken)
  removeFromStorage(STORAGE_KEYS.shouldRememberCustomer)

  return true
}
